import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap";
import { NgForm } from "@angular/forms";
import { Column, OrderManagementConfig, SortType } from "../../../../objects/users/user";
import { OrderViewType } from "../../../../objects/management/order/orderViewType";
import { UserViewService } from "../../../../services/userViewService";
import { Component as ComponentEnum } from "../../../../objects/components/component";
import { BlurUtil } from "../../../../common/utils/blurUtil";
import * as ps from "perfect-scrollbar";

@Component({
    selector: 'order-column-modal',
    templateUrl: 'order-column-modal.component.html',
    moduleId: module.id.toString()
})
export class OrderColumnModalComponent {
    @ViewChild('orderColumnModal')
    public orderColumnModal: ModalDirective;

    @ViewChild("orderColumnForm")
    public orderColumnForm: NgForm;

    @ViewChild('orderColumnModalRef')
    public orderColumnModalRef: ElementRef;

    @Input()
    public idToBlur: string;

    @Output()
    public columnsSaved: EventEmitter<boolean> = new EventEmitter();

    @Output()
    public sortChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    public config: OrderManagementConfig;
    public currentConfig: OrderManagementConfig;

    public columns: Column[] = [];

    public sortType = SortType;

    private isSortChanged: boolean = null;
    public isSaving: boolean = false;

    public get isMoreThanOneSelected(): boolean {
        return this.columns.find(c => c.IsSelected == true) != null;
    }

    public constructor(public userViewService: UserViewService) {

    }

    public get title(): string {
        if (!this.config)
            return 'Edit Tile';

        return this.config.ViewType == OrderViewType.Table ? 'Edit Table' : 'Edit Tile';
    }

    public async show(config: OrderManagementConfig): Promise<void> {
        this.config = config;
        this.currentConfig = JSON.parse(JSON.stringify(config));

        this.columns = this.currentConfig.ColumnsConfigs.find((x: any) => x.Type == this.config.ViewType).Columns;

        this.columns.sort((a, b) => {
            return a.Index - b.Index
        });

        this.orderColumnModal.show();
        BlurUtil.blurMenu(this.idToBlur);
        this.isSortChanged = false;
    }

    public ngOnInit(): void {
        ps.initialize(this.orderColumnModalRef.nativeElement);
    }

    public onModalHidden(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public save(): void {
        if (!this.isMoreThanOneSelected || this.isSaving)
            return;

        this.isSaving = true;

        this.userViewService.userView[ComponentEnum.OrderManagement] = JSON.parse(JSON.stringify(this.currentConfig));

        this.userViewService.modify(this.currentConfig).then(x => {
            this.userViewService.userView[ComponentEnum.OrderManagement] = x.Data;
            this.orderColumnModal.hide();
            this.isSaving = false;
        });

        this.columnsSaved.emit();

        if(this.isSortChanged == true)
            this.sortChanged.emit(true);
    }

    public setSort(sortType: SortType, column: Column) {
        this.columns.forEach(c => c.SortType = SortType.None);

        column.SortType = sortType;

        this.isSortChanged = true;
    }

    public handleDrop(event: any) {
        let index = Array.prototype.indexOf.call(event.source.children, event.el);// t.dropIndex;

        index += 1;

        if(event.value.Index > index){ // down
            this.columns.filter(x => x.Index >= index && x.Index <  event.value.Index).forEach(x=> x.Index +=1);

        }

        if(event.value.Index < index){ // up
            this.columns.filter(x => x.Index > event.value.Index && x.Index <= index).forEach(x=> x.Index -=1)
        }

        event.value.Index = index;
    }

    public isLocationField(column: Column): boolean {
        if (column.Name == 'Shipment From' || column.Name == 'Shipment To')
            return true;

        return false;
    }
}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/order-column-modal/order-column-modal.component.ts